<template>
  <div class="va-audio-file-input">
    <div class="d-flex align-center">
      <v-file-input
        class="flex-grow-1"
        @change="fileChanged"
        :value="file"
        :loading="loading"
        :label="label"
        accept=".mp3, .wav"></v-file-input>
      <v-btn
        v-if="downloadFileId || fileUrl"
        type="link"
        :ripple="false"
        plain
        class="ml-2 va-audio-file-input__action"
        @click="downloadFile">
        <v-icon small class="mr-1">mdi-download</v-icon>
        {{ $t("generic.buttons.download") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { sendToServer, downloadMediaObject } from "../../utility/mediaObjectUploadHelper";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "VaAudioFileInput",
    props: {
      fileId: {
        type: String,
        required: false,
        default: "",
      },
      fileName: {
        type: String,
        required: false,
        default: "",
      },
      fileUrl: {
        type: String,
        required: false,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        file: null,
        uploadedFileId: "",
      };
    },
    computed: {
      downloadFileId() {
        return this.uploadedFileId || this.fileId;
      },
    },
    watch: {
      fileName: {
        immediate: true,
        handler(val) {
          if (val) {
            try {
              const file = new File([""], val);
              this.file = file;
            } catch (e) {
              console.log(e);
            }
          } else {
            this.file = null;
          }
        },
      },
    },
    methods: {
      async downloadFile() {
        if (this.downloadFileId) {
          try {
            await downloadMediaObject(this.downloadFileId, this.fileName);
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
          }
        } else if (this.fileUrl) {
          (window.top || window).open(this.fileUrl, "_blank");
        }
      },
      async fileChanged(file) {
        // Prevent empty file upload
        if (file && file.size === 0) {
          return;
        }
        if (file) {
          this.loading = true;
          try {
            const res = await sendToServer(file);
            this.file = file;
            this.uploadedFileId = res["@id"] || "";
            this.$emit("update:file", { ...res, fileName: file.name });
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
          } finally {
            this.loading = false;
          }
        } else {
          this.uploadedFileId = "";
          this.$emit("update:file", null);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";

  .va-audio-file-input {
    ::v-deep .v-file-input__text {
      padding-left: 8px;
    }

    &__action {
      color: get-color("secondary-btn");

      i {
        transition: none;
      }

      &:hover {
        color: get-color("same-hover");
      }
    }
  }
</style>
